import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { SiteEmbedSettings } from "@/components/features-new/settings-external-connection/site-embed";

import { useConfirmParams } from "./hooks";

export const SettingsExternalConnectionSiteEmbedPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta
			title="サイト埋め込みの設定"
			url={generatePath(PATHS.SETTINGS.EXTERNAL_CONNECTION.SITE_EMBED, { hotelID })}
		>
			<SiteEmbedSettings hotelID={hotelID} />
		</PageMeta>
	);
};

SettingsExternalConnectionSiteEmbedPage.displayName = "SettingsExternalConnectionSiteEmbedPage";
